import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { showMessage } from '../../../../helpers/message';
import infracoes_api from '../../../../api/infracoes_api';

// Components
import FichaRoc from '../../FichaImpressaoCompleta/_components/FichaRoc';
import CartaoFicha from '../../FichaImpressaoCompleta/_components/CartaoFicha';
import RodapeEmissor from '../../FichaImpressaoCompleta/_components/RodapeEmissor';

const pageStyleFichaRoc = `
@page { size: auto; margin: 0mm; }
@media print { body { -webkit-print-color-adjust: exact; } }
@media print {
  @page { size:A4; margin:0; }
  .noPrint { display:none; }
}
`;
 
export default function FichaRocSeparada({ hash, parametrizacaoHash, numeroInfracao }) {
    const [ficha, setFicha] = useState(null);
    const ref = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        documentTitle: "Ficha do Protocolo (Sistema de Cadastros)",
        pageStyle: pageStyleFichaRoc
    });

    useEffect(() => {
        infracoes_api.GetImpressaoItemDadosRoc(hash, parametrizacaoHash)
            .then(({ data }) => setFicha(data))
            .catch(error => showMessage("Aviso", error?.message ?? "Não foi possível carregar o documento.", "warning", null));
    }, [hash, parametrizacaoHash]);

    if (!ficha) return <></>;

    return (
        <div className="d-flex flex-column p-3">
            <div className="noPrint d-flex justify-content-end mb-3">
                <Button color="danger" onClick={handlePrint}>
                    <FontAwesomeIcon icon={faFilePdf} /> Imprimir
                </Button>
            </div>
            <div ref={ref}>
                <CartaoFicha titulo="Ficha do Protocolo">
                    <FichaRoc ficha={ficha} />
                    <RodapeEmissor numeroInfracao={numeroInfracao} />
                </CartaoFicha>
            </div>
        </div>
    );
}
